





































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Cutoverplan } from '@/types';

@Component({})
export default class CutoverplanHashDialog extends Vue {
  @Prop()
  cutoverplan!: Cutoverplan;

  @Prop()
  hash!: any;

  @Prop({ default: () => false })
  dialog!: boolean;
}
